export default {
  'EditArtistProfileLayout.title': {
    en: 'Edit your Profile',
    fr: 'Modifier votre profil',
  },
};
